import { render, staticRenderFns } from "./ClientComponent.vue?vue&type=template&id=35acc9fa&scoped=true&"
import script from "./ClientComponent.vue?vue&type=script&lang=js&"
export * from "./ClientComponent.vue?vue&type=script&lang=js&"
import style0 from "./ClientComponent.vue?vue&type=style&index=0&id=35acc9fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35acc9fa",
  null
  
)

component.options.__file = "ClientComponent.vue"
export default component.exports